// 引入api请求方法
// import base from "@/utils/base"
const state = {
  isCompany: false,
  isPwd: false,
  // 登录返回的信息
  loginData: {
    // 名字 ，用户名字
    name: '',
    // 所属公司列表
    companys: [],
    // 是否设置密码
    hasPassword: false,
    // 是否有万金油企业
    onlyWJY: false,
  },
  erweima: false,
  // erweima: true
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async () => {},
};

// mutations
const mutations = {
  // 更新data数据
  updateStateData(state, payload) {
    Object.assign(state, payload);
  },
  updateErweima(state, payload) {
    state.erweima = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
